import React, {Component, Fragment} from 'react'
import {connect} from 'react-redux'
import autobind from 'autobind-decorator'
import {Modal, ModalHeader, ModalBody, Button, ModalFooter} from 'reactstrap'
import {remove} from 'catalog/actions/measures'

@connect(
    null,
    dispatch => ({
        remove: measure => dispatch(remove(measure))
    })
)
export default class DeleteMeasure extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isOpen: false
        }
    }

    @autobind
    toggle() {
        const isOpen = !this.state.isOpen
        this.setState({isOpen})
    }

    @autobind
    confirm() {
        this.props.remove(this.props.measure)
        this.toggle()
    }

    render() {
        const { measure } = this.props
        return (
            <Fragment>
                     <Button color='danger' title='Maßnahme löschen' onClick={this.toggle}>
                                <i className='fa fa-trash'> </i>
                            </Button>
                            <Modal isOpen={this.state.isOpen}>
                    <ModalHeader>
                        Maßnahme löschen
                    </ModalHeader>
                    <ModalBody>
                        Sind Sie sicher, dass Sie die Maßnahme:
                        <blockquote>
                            {measure.name}
                        </blockquote>
                        löschen möchten?
                    </ModalBody>
                    <ModalFooter>
                        <Button color='danger' onClick={this.confirm}>Bestätigen</Button>
                        <Button color='default' onClick={this.toggle}>Abbrechen</Button>
                    </ModalFooter>
                </Modal>
            </Fragment>   
        )
    }
}